module.exports = __webpack_public_path__ + "media/images/arrows/bullet-cyan-d520304d18cd1ce7359309a82646cf30.svg";